import React, { Fragment } from "react";
import { Outlet } from "react-router-dom";

const WeekReport = ({ match }) => {
    return (
        <Outlet />
    )
};

export default WeekReport;